import React from "react";

import HighlightedTitleStyle from "./highlighted-title";

export default () => (
  <>
    <HighlightedTitleStyle />
  </>
);
